/** Edad en años a partir de una fecha ISO de nacimiento. */
export function edadEnAnios(fechaNacimientoISO: string, hoy = new Date()): number {
  const nac = new Date(fechaNacimientoISO);
  if (Number.isNaN(nac.getTime())) return 0;
  let edad = hoy.getFullYear() - nac.getFullYear();
  const m = hoy.getMonth() - nac.getMonth();
  if (m < 0 || (m === 0 && hoy.getDate() < nac.getDate())) edad--;
  return Math.max(0, edad);
}
